import React from 'react';
import { Link } from 'react-router-dom';

function Verification() {
  return (
    <div className="docs-content">
      <h1>Document Verification</h1>
      <p className="docs-lead">
        Anyone with a document reference can verify that a document was signed through SignTada—no account required. This builds trust and transparency for your signers and auditors.
      </p>

      <h2>Public verify page</h2>
      <p>
        SignTada provides a public <strong>Verify</strong> page (e.g. <code>/verify</code> on your deployment). Anyone with the document reference (e.g. the ID or token from the signing link) can enter it and confirm that the document was processed and signed via SignTada. No login or API key is needed. This is useful for signers who want to double-check authenticity, or for auditors and partners who need to validate that a signature was captured through your platform.
      </p>

      <h2>What verifiers see</h2>
      <p>
        The verification result typically indicates whether the document exists, that it was signed through SignTada, and may show high-level status (e.g. signed, pending). It does not expose sensitive content or full audit details to unauthenticated users; those remain available to authorized users via the dashboard or API.
      </p>

      <h2>Linking from your app</h2>
      <p>
        You can link to the verify page from your own app, emails, or support pages. For example: “Verify this document at [your-domain]/verify” with the reference in the URL or as a query parameter. This gives recipients and third parties a clear way to confirm that a signature was collected through SignTada.
      </p>

      <p>
        <Link to="/signing-flow">← Signing Flow</Link> · <Link to="/branding">Branding →</Link>
      </p>
    </div>
  );
}

export default Verification;
